import { makeStyles, Theme } from '@material-ui/core';

type StylesProps = {
  isExpanded?: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  tableItem: ({ isExpanded }: StylesProps) => ({
    display: 'flex',
    borderBottom: isExpanded ? `${theme.spacing(0.13)} solid ${theme.palette.gray[300]}` : 'none',

    '&:last-child *': {
      border: 'none',
    },
  }),
  itemSection: {
    width: '100%',
  },
  itemContainer: {
    display: 'flex',
    '&:hover': {
      backgroundColor: theme.palette.blue[50],
      transition: 'background-color 0.3s ease-in-out',
    },
  },
  subItemContainer: {
    padding: theme.spacing(0, 1.5, 0, 5),
  },
}));

export default useStyles;
